/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_TruncatedInputs */

const en_cc_truncated = /** @type {(inputs: Cc_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The list displays at most 100 results.`)
};

const id_cc_truncated = /** @type {(inputs: Cc_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar menampilkan paling banyak 100 hasil.`)
};

/**
* | output |
* | --- |
* | "The list displays at most 100 results." |
*
* @param {Cc_TruncatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_truncated = /** @type {((inputs?: Cc_TruncatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_TruncatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_truncated(inputs)
	return en_cc_truncated(inputs)
});